export const expensereportdata = [
  {
    id: "1",
    Date: "01 Jan 2024",
    ExpenseCategory: "Printing",
    img: "assets/img/users/user-05.jpg",
    User: "Mitchum Daniel",
    Amount: "$14,174",
  },
  {
    id: "2",
    Date: "14 Jan 2024",
    ExpenseCategory: "Utilities",
    img: "assets/img/users/user-02.jpg",
    User: "Susan Lopez",
    Amount: "$19,474",
  },
  {
    id: "3",
    Date: "25 Jan 2024",
    ExpenseCategory: "Travel",
    img: "assets/img/users/user-03.jpg",
    User: "Robert Grossman",
    Amount: "$20,744",
  },
  {
    id: "4",
    Date: "01 May 2024",
    ExpenseCategory: "Purchase",
    img: "assets/img/users/user-04.jpg",
    User: "Russell Belle",
    Amount: "$25,474",
  },
  {
    id: "5",
    Date: "14 Oct 2024",
    ExpenseCategory: "Printing",
    User: "Edward K. Muniz",
    Amount: "$12,436",
  },
];
